import { useToast } from '@app/core/notifications';
import { useRouter } from '@mi-front/core';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../api';

interface Props {
  readonly id: string;
  readonly name: string;
}

export const ReportDeleteBtn = ({ id, name }: Props) => {
  const { formatMessage } = useIntl();
  const { notifySuccess, notifyError } = useToast();
  const { history } = useRouter();
  const [open, setOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await apiClient.reports.deleteReport(id);

      notifySuccess(
        formatMessage({
          id: 'audit.reportDelete.deleted',
          defaultMessage: 'Reporte eliminado',
        }),
      );
      history.replace('/audit/saved-reports');
    } catch (err: any) {
      notifyError(
        formatMessage({
          id: 'audit.reportDelete.deleteError',
          defaultMessage: 'No se pudo eliminar el reporte',
        }),
      );
      throw err;
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="error"
        startIcon={<DeleteIcon />}
        onClick={() => setOpen(true)}
      >
        {formatMessage({
          id: 'common.actions.delete',
          defaultMessage: 'Eliminar',
        })}
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          {formatMessage({
            id: 'audit.reportDelete.title',
            defaultMessage: 'Eliminar reporte',
          })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {formatMessage(
              {
                id: 'audit.reportDelete.prompt',
                defaultMessage: `
        Deseas realmente eliminar el reporte? {br}
        Esta acción no se puede deshacer.
      `,
              },
              { br: <br /> },
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={isDeleting}>
            {formatMessage({
              id: 'common.actions.cancel',
              defaultMessage: 'Cancelar',
            })}
          </Button>
          <Button onClick={handleDelete} loading={isDeleting} color="error" variant="contained">
            {formatMessage({
              id: 'common.actions.delete',
              defaultMessage: 'Eliminar',
            })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
